import React, { useState } from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import FiltersFilter from '../../FiltersFilter';
import FiltersField from '@afosto/app-components-react/FiltersField';
import translations from './translations';

const FiltersFormSection = () => {
  const intl = useIntl();
  const [filterOptions] = useState([
    {
      label: intl.formatMessage(translations.filterTypes.sku),
      value: 'sku',
    },
    {
      label: intl.formatMessage(translations.filterTypes.filter),
      value: 'filter',
    },
    {
      label: intl.formatMessage(translations.filterTypes.isDiscounted),
      value: 'is_discounted',
    },
    {
      label: intl.formatMessage(translations.filterTypes.per),
      value: 'per',
    },
  ]);

  const handleFetchOperators = () => [
    {
      label: intl.formatMessage(translations.operators.in),
      value: 'in',
    },
  ];

  const handleFetchFormat = key => {
    if (key === 'is_discounted') {
      return 'boolean';
    }

    if (key === 'per') {
      return 'number';
    }

    if (key === 'filter') {
      return 'filters';
    }

    return null;
  };

  return (
    <Card style={{ marginBottom: 8 }}>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        <FiltersField
          showLabel={false}
          filterOptions={filterOptions}
          formatters={{
            filters: FiltersFilter,
          }}
          onFetchOperators={handleFetchOperators}
          onFetchFormat={handleFetchFormat}
        />
      </CardContent>
    </Card>
  );
};

export default FiltersFormSection;
